import * as types from "../types/auth.types";

const initialState = {
  user: [],
  token: "",
  user_loading: false,
  data: [],
  name: "",
  walletName: "",
  navbar_collapsed: false, // true = close, false = open
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DATA:
      return { ...state, data: action.payload };
    case types.SET_NAME:
      return { ...state, name: action.payload };
    case types.SET_USER:
      return { ...state, user: action.payload };
    case types.SET_TOKEN:
      return { ...state, token: action.payload };
    case types.SET_USER_LOADING:
      return { ...state, user_loading: action.payload };
    case types.NAVBAR_COLLAPSED:
      return { ...state, navbar_collapsed: action.payload };
    case types.LOGOUT_USER:
      return { 
        ...state, 
        user: [], 
        token: "", 
        user_loading: false, 
        data: [],
        name: "",
        walletName: "",
        navbar_collapsed: false,
      };
    default:
      return state;
  }
};
export default AuthReducer;
